module.exports = __webpack_public_path__ + "img/course-cover05.a44e64ab.png";